var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M384,192c0,60.97-28.43,115.29-72.74,150.46-32.76,26-205.77,25.98-238.52,0C28.4,307.3,0,252.98,0,192,0,85.96,85.96,0,192,0s192,85.96,192,192h0Zm0,0",
    style: {
      fill: "#645faa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.49,149.31c17.5-4.69,48.7,2.15,53.39,19.65,4.69,17.49-18.92,39.02-36.41,43.71-17.5,4.69-22.25-9.24-26.94-26.73-4.69-17.49-7.53-31.93,9.96-36.62h0Zm0,0",
    style: {
      fill: "#fbad7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,149.31c-17.5-4.69-48.7,2.15-53.39,19.65-4.69,17.49,18.92,39.02,36.41,43.71,17.5,4.69,22.25-9.24,26.94-26.73,4.69-17.49,7.53-31.93-9.96-36.62h0Zm0,0",
    style: {
      fill: "#fbbd94"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,384c45.07,0,86.5-15.54,119.26-41.54-20.87-15.88-46.81-27.64-75.73-33.6-3.5-.72-6.03-3.78-6.03-7.36v-73.31h-75v73.31c0,3.58-2.53,6.63-6.03,7.36-28.92,5.96-54.86,17.71-75.73,33.6,32.76,26,74.19,41.54,119.26,41.54h0Zm0,0",
    style: {
      fill: "#fbbd94"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,304.93c-.53-1.03-.83-2.19-.83-3.41v-73.31h-75v73.31c0,3.58-2.53,6.63-6.03,7.36-28.92,5.96-54.86,17.71-75.73,33.6,9.58,7.61,19.92,14.31,30.86,20,28.51-32.19,74.29-54.16,126.73-57.54h0Zm0,0",
    style: {
      fill: "#fbad7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,308.28c-5.52,17.84-22.15,30.8-41.8,30.8s-36.28-12.96-41.8-30.8c-.54,.26-1.12,.46-1.73,.59-28.92,5.96-54.86,17.71-75.73,33.6,32.76,26,74.19,41.54,119.26,41.54s86.5-15.54,119.26-41.54c-20.87-15.88-46.81-27.64-75.73-33.6-.61-.13-1.19-.33-1.73-.59h0Zm0,0",
    style: {
      fill: "#fae17c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.14,345.11c.33,.25,.66,.49,.99,.73,.84,.63,1.68,1.25,2.53,1.86,.36,.26,.72,.52,1.08,.77,.86,.61,1.72,1.21,2.59,1.81,.32,.22,.64,.44,.96,.66,.98,.66,1.96,1.32,2.95,1.96,.21,.14,.41,.27,.62,.41,5.09,3.29,10.33,6.34,15.74,9.15,14.26-16.11,32.84-29.65,54.42-39.59-3.47-4.27-6.15-9.21-7.82-14.6-.25,.12-.5,.22-.76,.31-.04,.02-.09,.03-.14,.05-.27,.09-.55,.17-.83,.23-16.27,3.35-31.59,8.54-45.6,15.26-4.67,2.24-9.19,4.65-13.56,7.22-5.82,3.43-11.36,7.14-16.57,11.11,1.12,.89,2.26,1.77,3.41,2.64h0Zm0,0",
    style: {
      fill: "#f8c14c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.79,153.94c0-64.73,52.48-117.21,117.21-117.21s117.21,52.48,117.21,117.21-17.13,130.51-117.21,130.51-117.21-65.78-117.21-130.51h0Zm0,0",
    style: {
      fill: "#fcd2ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.79,153.94V75.64c-18.65,20.76-30,48.2-30,78.3,0,64.74,17.13,130.51,117.21,130.51,1.41,0,2.8-.02,4.18-.04,.75-.02,1.49-.04,2.23-.06,.56-.02,1.11-.03,1.66-.05,.99-.04,1.96-.08,2.93-.13,.24-.02,.47-.03,.7-.04,1.11-.06,2.22-.13,3.32-.21-86.81-6.34-102.21-68.62-102.21-129.97h0Zm0,0",
    style: {
      fill: "#fbbd94"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.82,151.03C61.37,79.46,120.07,21.73,192,21.73s130.61,57.72,132.18,129.28h-15.03v9.58h-15c-8.29,0-15-6.71-15-15v-19.84c0-8.29-6.72-15-15-15H119.85c-8.29,0-15,6.71-15,15v19.84c0,8.29-6.71,15-15,15h-15v-9.56h-15.04Zm0,0",
    style: {
      fill: "#441c4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.21,138.75h-84.42c-33.14,0-60-26.86-60-60s26.86-60,60-60h136.92c4.14,0,7.5,3.36,7.5,7.5v52.5c0,33.14-26.86,60-60,60h0Zm0,0",
    style: {
      fill: "#623a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.79,78.75c0-33.14,26.86-60,60-60h-30c-33.14,0-60,26.86-60,60s26.86,60,60,60h30c-33.14,0-60-26.86-60-60h0Zm0,0",
    style: {
      fill: "#441c4e"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfImg);
export default __webpack_public_path__ + "static/media/prof_img.ddbf23522b1d98bdf5747eec2087291e.svg";
export { ForwardRef as ReactComponent };